import { addBusinessDays, startOfToday } from "date-fns"

import { range } from "@p-ban/common/src/utils/NumberUtils"

import useReceivableDatesQuery from "../../../../../api/schedule/useReceivableDatesQuery"

const fallbackDates = [...range(0, 15)].map((i) => addBusinessDays(startOfToday(), i + 1))

const useReceivableDates = () => {
  const fetchedDates = useReceivableDatesQuery()

  const existsResponse = !!fetchedDates
  const includeDates = fetchedDates ?? fallbackDates
  const minDate = includeDates[0] as Date
  const maxDate = includeDates[includeDates.length - 1] as Date

  return { existsResponse, includeDates, minDate, maxDate }
}

export default useReceivableDates
